var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3H1C0.801088 3 0.610322 3.07902 0.46967 3.21967C0.329018 3.36032 0.25 3.55109 0.25 3.75V17.25C0.25 17.4489 0.329018 17.6397 0.46967 17.7803C0.610322 17.921 0.801088 18 1 18H14.5C14.6989 18 14.8897 17.921 15.0303 17.7803C15.171 17.6397 15.25 17.4489 15.25 17.25V3.75C15.25 3.55109 15.171 3.36032 15.0303 3.21967C14.8897 3.07902 14.6989 3 14.5 3ZM13.75 16.5H1.75V4.5H13.75V16.5ZM18.25 0.75V14.25C18.25 14.4489 18.171 14.6397 18.0303 14.7803C17.8897 14.921 17.6989 15 17.5 15C17.3011 15 17.1103 14.921 16.9697 14.7803C16.829 14.6397 16.75 14.4489 16.75 14.25V1.5H4C3.80109 1.5 3.61032 1.42098 3.46967 1.28033C3.32902 1.13968 3.25 0.948912 3.25 0.75C3.25 0.551088 3.32902 0.360322 3.46967 0.21967C3.61032 0.0790178 3.80109 0 4 0H17.5C17.6989 0 17.8897 0.0790178 18.0303 0.21967C18.171 0.360322 18.25 0.551088 18.25 0.75Z",
    fill: "#2D2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconSvg);
export default __webpack_public_path__ + "static/media/CopyIconSVG.bdc10d15ec0c94c52785e97db83fae1e.svg";
export { ForwardRef as ReactComponent };